import { RESILIENCE_AWARD_TIERS } from '../data/awards.js';
import { PLANT_BY_ID } from '../data/plants.js';
import { FAMILY } from '../data/families.js';

export function portfolioHasFossilThermal({
  portfolio,
  plantsById = PLANT_BY_ID
}) {
  return (portfolio ?? []).some(
    (id) => plantsById[id]?.family === FAMILY.FOSSIL_THERMAL
  );
}

export function countDistinctFamiliesBuilt({
  portfolio,
  plantsById = PLANT_BY_ID
}) {
  const families = new Set();
  for (const id of portfolio ?? []) {
    const family = plantsById[id]?.family;
    if (family) families.add(family);
  }
  return families.size;
}

export function computeLargestFamilyShare({
  familyMWh,
  totalPostDisasterMWh
}) {
  if (!Number.isFinite(totalPostDisasterMWh)) return 0;
  if (totalPostDisasterMWh <= 0) return 0;
  const values = Object.values(familyMWh ?? {}).filter(Number.isFinite);
  if (values.length === 0) return 0;
  return Math.max(...values, 0) / totalPostDisasterMWh;
}

export function resilienceAwardTier({
  distinctFamiliesBuilt,
  largestFamilyShare,
  totalPostDisasterMWh,
  hasFossilThermal = false,
  tiers = RESILIENCE_AWARD_TIERS
}) {
  if (!Number.isFinite(totalPostDisasterMWh)) return null;
  if (totalPostDisasterMWh <= 0) return null;
  if (!Number.isFinite(distinctFamiliesBuilt)) return null;
  if (!Number.isFinite(largestFamilyShare)) return null;
  for (const tier of tiers) {
    if (tier.requiresFossilFreePortfolio && hasFossilThermal) continue;
    if (
      distinctFamiliesBuilt >= tier.minFamilies &&
      largestFamilyShare < tier.maxLargestFamilyShareExclusive
    ) {
      return tier;
    }
  }
  return null;
}

export function resilienceAwardAmount(input) {
  return resilienceAwardTier(input)?.bonus ?? 0;
}

export function computeResilienceAward({
  portfolio,
  familyMWh,
  totalPostDisasterMWh,
  plantsById = PLANT_BY_ID,
  tiers = RESILIENCE_AWARD_TIERS
}) {
  const distinctFamiliesBuilt = countDistinctFamiliesBuilt({
    portfolio,
    plantsById
  });
  const largestFamilyShare = computeLargestFamilyShare({
    familyMWh,
    totalPostDisasterMWh
  });
  const hasFossilThermal = portfolioHasFossilThermal({
    portfolio,
    plantsById
  });
  const tier = resilienceAwardTier({
    distinctFamiliesBuilt,
    largestFamilyShare,
    totalPostDisasterMWh,
    hasFossilThermal,
    tiers
  });
  return {
    amount: tier ? tier.bonus : 0,
    tier,
    distinctFamiliesBuilt,
    largestFamilyShare,
    hasFossilThermal
  };
}
